import axios from "axios";
import constants from "constants";
import { store } from "store";
import errorHandler from "./errorHandler";

const regenerateInvoiceService = axios.create({
	baseURL: constants.offlinePaymentServiceUrl
});

regenerateInvoiceService.interceptors.request.use(config => {
	let userInfo = store.getState().userInfo;
	config.headers[constants.authTokenBackendKey] = userInfo.authToken;
	config.headers["sessionID"] = userInfo.sessionId;
	return config;
});

regenerateInvoiceService.interceptors.response.use(function(response) {
	return response;
}, errorHandler);

export default regenerateInvoiceService;
